import { useState } from "react";
import { AddwithWhiteCircle, Attachment, DropdownArrow } from "./ReusableSVGs";

const DocumentSection = ({ formData, handleDocInputChange, handleAddDocuments, handleRemoveDocument, errors, fileNames, inputState }) => (
    <>
        <div className="jd-heading-outer heading-bg-color-white">
            <div className="jd-heading-outer-flex">
                <h2 className="jd-heading-main font-weight600 font-size-heading">Documents</h2>
                <button
                    title="Add Documents"
                    onClick={handleAddDocuments}
                    className="upload-svg"
                    style={{ float: "right" }}
                    type="button" // Set the button type to "button"
                >
                    <AddwithWhiteCircle /> Add Document
                </button>
            </div>
            <div>
                <div className="jd-heading-bottom-bold"></div>
                <div className="jd-heading-bottom-light"></div>
            </div>
        </div>

        {formData.documents.map((doc, index) => (
            <div key={index} style={{ display: 'flex' }}>
                <div className="flex-column">
                    <label htmlFor={`document_name_${index}`} className="form-labels font-weight500 font-size-subheading">
                        File Name<span className="required">*</span>
                    </label>
                    <input
                        type="text"
                        id={`document_name_${index}`}
                        name="document_name"
                        placeholder="Document Name"
                        value={doc.document_name}
                        onChange={(e) => handleDocInputChange(index, e)}
                        className={`form-input ${errors[`document_name_${index}`] ? 'error' : inputState[`document_name`] ? 'success' : ''}`}
                    />
                    {errors[`document_name_${index}`] && (
                        <span className="error-message font-size-text">{errors[`document_name_${index}`]}</span>
                    )}
                </div>

                <div className="flex-column field-cont-div" style={{ marginLeft: '60px', alignItems: 'flex-start' }}>
                    <label htmlFor={`document_file_${index}`} className="form-labels announce-date font-weight500 font-size-heading">
                        Upload File<span className="required">*</span>
                    </label>
                    <label
                        style={{ margin: '10px 0px' }}
                        htmlFor={`document_file_${index}`}
                        className={` custom-file-upload ${errors[`document_file_${index}`] ? 'error' : inputState[`document_file`] ? 'success' : ''}`}
                    >
                        <div className={`align-center pdf-input  ${errors[`document_file_${index}`] ? 'error' : ''}`}>
                            <Attachment />
                        </div>
                    </label>
                    <input
                        id={`document_file_${index}`}
                        name="document_file"
                        type="file"
                        onChange={(e) => handleDocInputChange(index, e)}
                        style={{ display: 'none', position: 'relative' }}
                    />
                    {fileNames[index] && <p className="file-name align-center">{fileNames[index]}</p>}
                    <div>
                        {errors[`document_file_${index}`] && (
                            <span className="error-message font-size-text">{errors[`document_file_${index}`]}</span>
                        )}
                    </div>
                </div>

                {index > 0 && (
                    <button type="button" className="model-button-cancel" onClick={() => handleRemoveDocument(index)}>
                        Remove
                    </button>
                )}
            </div>
        ))}
    </>
);

const RenderInputField = ({ title, name, required, type = 'text', placeholder, max, formData, errors, inputState, handleInputChange }) => (
    <div title={title} className="flex-column">
        <label htmlFor={name} className="form-labels font-weight500 font-size-subheading">
            {title}{required ? <span className="required">*</span> : null}
        </label>
        <input
            type={type}
            id={name}
            name={name}
            max={max}
            placeholder={placeholder}
            value={formData[name]}
            onChange={handleInputChange}
            className={`form-input ${errors[name] ? 'error' : inputState[name] ? 'success' : ''}`}
        />
        {/* {errors[name] && <span className="error-message font-size-text">{errors[name]}</span>} */}
    </div>
);

const RenderDateInputField = ({ title, name, required, type = 'date', placeholder, max, formData, errors, inputState, handleInputChange }) => {
    const [localError, setLocalError] = useState("");

    const handleChange = (e) => {
        let { value } = e.target;
        let errorMessage = "";

        if (type === "date" && max && value > max) {
            errorMessage = `Date cannot be later than ${max}`;
        }

        setLocalError(errorMessage);

        handleInputChange({ target: { name, value: errorMessage ? formData[name] : value } });
    };

    return (
        <div title={title} className="flex-column">
            <label htmlFor={name} className="form-labels font-weight500 font-size-subheading">
                {title}{required ? <span className="required">*</span> : null}
            </label>
            <input
                type={type}
                id={name}
                name={name}
                max={max}
                placeholder={placeholder}
                value={formData[name]}
                onChange={handleChange}
                className={`form-input ${errors[name] || localError ? 'error' : inputState[name] ? 'success' : ''}`}
            />
            {localError && <span className="error-message font-size-text">{localError}</span>}
        </div>
    );
};

const RenderInputTextareaField = ({ title, name, required, placeholder, max, formData, errors, inputState, handleInputChange, rows = 5, cols = 50 }) => (
    <div title={title} className="flex-column">
        <label htmlFor={name} className="form-labels font-weight500 font-size-subheading">
            {title}
            {required ? <span className="required">*</span> : null}
        </label>
        <textarea
            id={name}
            name={name}
            rows={rows}
            cols={cols}
            placeholder={placeholder}
            value={formData[name]}
            onChange={handleInputChange}
            maxLength={max} // Optional max length attribute
            className={`form-textarea ${errors[name] ? 'error' : inputState[name] ? 'success' : ''}`}
            style={{ whiteSpace: 'pre-wrap' }} // Preserve new lines and spaces
        />
        {/* {errors[name] && <span className="error-message font-size-text">{errors[name]}</span>} */}
    </div>
);

const RenderSelectField = ({ title, name, required, options, placeholder, disabled, formData, errors, inputState, handleInputChange, multiple = false }) => (
    <div title={title} className="flex-column form-group-selectt">
        <label htmlFor={name} className="form-labels font-weight500 font-size-subheading">
            {title}{required ? <span className="required">*</span> : null}
        </label>
        <br />
        <select
            id={name}
            name={name}
            value={formData[name]}
            onChange={handleInputChange}
            className={`form-input form-group-selection ${errors[name] ? 'error' : inputState[name] ? 'success' : ''}`}
            disabled={disabled}
            multiple={multiple}
        >
            <option value="null" disabled>{placeholder}</option>
            {options?.map((option, index) => (
                <option key={index} value={option.value}>{option.label}</option>
            ))}
        </select>
        <DropdownArrow />
        {/* {errors[name] && <span className="error-message font-size-text">{errors[name]}</span>} */}
    </div>
);

const InputTextField = ({
    title,
    htmlFor,
    name,
    type = "text",
    placeholder,
    onChange,
    value,
    errors,
    inputState
}) => {

    console.log(inputState[name])
    return (
        <div title={title} className="flex-column">
            <label htmlFor={htmlFor} className="form-labels font-weight500 font-size-subheading">
                {title}<span className="required">*</span>
            </label>
            <input
                type={type}
                id={htmlFor}
                name={name}
                placeholder={placeholder}
                onChange={onChange}
                value={value}
                className={`form-input ${errors[name] ? "error" : inputState[name] ? "success" : ""}`}
            />
            {errors[name] && <span className="error-message font-size-text">{errors[name]}</span>}
        </div>
    );
};

export {
    InputTextField,
    DocumentSection,
    RenderInputField,
    RenderDateInputField,
    RenderSelectField,
    RenderInputTextareaField
}